import WalkingIcon from 'src/assets/vehicles/hike.svg?react';
import CyclingIcon from 'src/assets/vehicles/bicycle.svg?react';
import MotorbikeIcon from 'src/assets/vehicles/motorbike.svg?react';
import TuktukIcon from 'src/assets/vehicles/tuktuk.svg?react';
import CarIcon from 'src/assets/vehicles/car.svg?react';
import TruckIcon from 'src/assets/vehicles/truck.svg?react';
import CampervanIcon from 'src/assets/vehicles/small-campervan.svg?react';
import CampervanLargeIcon from 'src/assets/vehicles/large-campervan.svg?react';
import RVIcon from 'src/assets/vehicles/rv.svg?react';
import UnimogIcon from 'src/assets/vehicles/unimog.svg?react';

export const TRANSPORT_MODE_MAPPINGS = {
  Motorbike: {
    label: 'Motorbike',
    profile: 'driving',
    icon: MotorbikeIcon
  },
  Car: {
    label: 'Car',
    profile: 'driving',
    icon: CarIcon
  },
  Truck: {
    label: 'Truck',
    profile: 'driving',
    icon: TruckIcon
  },
  Campervan: {
    label: 'Small Camper',
    profile: 'driving',
    icon: CampervanIcon
  },
  CampervanLarge: {
    label: 'Campervan',
    profile: 'driving',
    icon: CampervanLargeIcon
  },
  RV: {
    label: 'RV',
    profile: 'driving',
    icon: RVIcon
  },
  Unimog: {
    label: 'Expedition Truck',
    profile: 'driving',
    icon: UnimogIcon
  },
  Walking: {
    label: 'Hiking',
    profile: 'walking',
    icon: WalkingIcon
  },
  Cycling: {
    label: 'Bikepacking',
    profile: 'cycling',
    icon: CyclingIcon
  },
  Tuktuk: {
    label: 'Tuktuk',
    profile: 'driving',
    icon: TuktukIcon
  },
};

export function getTransportProfile(mode) {
  return TRANSPORT_MODE_MAPPINGS[mode]?.profile || 'driving';
}

export function getTransportMode(mode) {
  return TRANSPORT_MODE_MAPPINGS[mode] || TRANSPORT_MODE_MAPPINGS["Car"];
}